<template>
  <div class="modal-Playback">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">回放</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <el-row>
          <el-col :span="24">
            <div class="view">
              <iframe
                  id="iframes"
                  ref="iframe"
                  :src=src
                  frameborder="0"
                  width="900"
                  height="450"
                  scrolling="auto"
              >
              </iframe>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>


export default {
  name: "Preview",
  data() {
    return {
      uid: '',
      password: '',
      iframeWin: {},
      name: '',
      par: '',
      data: '',
      src:''

    }

  },
  components: {},



  created() {

  },
  methods: {
    init(row) {

      this.uid = row.uid;
      this.password = row.password;
      this.name = row.name;
      this.src='/SDPlay.html?uid='+row.uid+'&password='+row.password;
      // this.src='/SDPlay.html';


    },


    closeSelf() {
      this.$emit("closePlayback");
    },



  },
  mounted() {

  }

}
</script>

<style lang="scss" scoped>


.modal-Playback {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 900px;
    height: 600px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      overflow-y: auto;
      height: 100%;

      .view {
        margin: 0 auto;

      }

    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


</style>